/* eslint-disable import/no-unresolved */
import { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';

import { RENAME_DIRECTORY_OR_FILE } from 'Apollo/Mutations/DataRecon';
import RenameFile from '../components/RenameFile';

const RenameFileContainer = ({
    visible, setVisible, getDirDetails, fileExplorerDataSource, selectedFiles, parentDir, setToastMessage,
}) => {
    const [fileName, setFileName] = useState('');
    const [fileNameError, setFileNameError] = useState(false);
    const [fileNameIsValid, setFileNameIsValid] = useState(false);

    const [renameFolderOrFile, { loading: renameFolderOrFileIsLoading }] = useMutation(RENAME_DIRECTORY_OR_FILE);

    const oldFileName = fileExplorerDataSource && fileExplorerDataSource.find(element => element.id === selectedFiles[0]);

    useEffect(() => {
        setFileName(oldFileName.name);
    }, [selectedFiles, fileExplorerDataSource]);

    const reg = new RegExp('^[^\\/?*:|"<>]+$');

    const inputHandler = value => {
        setFileName(value);
        if (value.trim() === '') {
            setFileNameError(true);
        } else {
            setFileNameError(false);
        }
    };

    const onBlurHandler = (event => {
        if (event.target.value.trim() === '') {
            setFileNameError(true);
        } else {
            setFileNameError(false);
        }

        if (event.target.value.trim() !== '' && !reg.test(event.target.value.trim())) {
            setFileNameIsValid(true);
        } else {
            setFileNameIsValid(false);
        }
    });

    const onSave = async () => {
        setFileNameError(false);
        if (!fileName || fileName.trim() === '') {
            setFileNameError(true);
            return;
        }
        if (fileName.trim() !== '' && !reg.test(fileName.trim())) {
            setFileNameIsValid(true);
            return;
        }

        if (renameFolderOrFileIsLoading) {
            return;
        }

        await renameFolderOrFile({
            variables: {
                dirId: parentDir,
                id: oldFileName.originalId,
                newName: fileName,
                type: oldFileName.type,
            },
        }).then(() => {
            setToastMessage('Folder/File is renamed.');
        });
        setVisible(false);
        getDirDetails();
    };

    return (
        <RenameFile
            visible={visible}
            setVisible={setVisible}
            fileName={fileName}
            fileNameError={fileNameError}
            fileNameIsValid={fileNameIsValid}
            inputHandler={inputHandler}
            onBlurHandler={onBlurHandler}
            onSave={onSave}
            type={oldFileName.type}
            renameFolderOrFileIsLoading={renameFolderOrFileIsLoading}
        />
    );
};

export default RenameFileContainer;
